import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  sales_manuals: [],
};

const sales_manual = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default sales_manual;
